import EventEmitter from 'events';

export default new EventEmitter();



/** WEBPACK FOOTER **
 ** ./src/utils/emitter.js
 **/